import React from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { SectionContainer } from 'components/Containers/SectionContainer/SectionContainer';
import { Row } from 'components/Containers/Row/Row';
import Label from 'components/form/Label/Label';
import './OcfHeaderTemplateModuleView.scss';

const OcfHeaderTemplateModuleView = props => {
  return (
    <SectionContainer>
      <Row>
        <FlexContainer
          className={'headerTemplaceOcfContainer justify-between m-flex-column'}
        >
          <FlexContainer className={'titleContainer flex-column'}>
            <Label className={'H2 m-H3'}>
              {props?.headerContainerConfig?.title}
            </Label>

            <Label className={'Body-1 margT16'}>
              {props?.headerContainerConfig?.subTitle}
            </Label>
          </FlexContainer>
          <FlexContainer className={'justify-center m-margT10'}>
            <img
              alt={`header template`}
              src={props?.headerContainerConfig?.imageUrl}
              className="image"
            />
          </FlexContainer>
        </FlexContainer>
      </Row>
    </SectionContainer>
  );
};

export default OcfHeaderTemplateModuleView;
